/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_Carrier_CodInputs */

const vi_error_payment_method_change_carrier_cod = /** @type {(inputs: Error_Payment_Method_Change_Carrier_CodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản này là tiền hãng vận chuyển thu hộ (COD), hình thức theo đối soát với hãng nên không đổi ở đây được.`)
};

/**

* @param {Error_Payment_Method_Change_Carrier_CodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_carrier_cod = /** @type {((inputs?: Error_Payment_Method_Change_Carrier_CodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_Carrier_CodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_carrier_cod(inputs)
});